import * as React from "react";
const SvgProfil = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="Profil">
    <path
      fill="currentColor"
      d="M128 128.98c28.24 0 51.21-22.97 51.21-51.21S156.24 26.56 128 26.56 76.79 49.53 76.79 77.77s22.97 51.21 51.21 51.21m0-87.42c19.97 0 36.21 16.24 36.21 36.21s-16.24 36.21-36.21 36.21-36.21-16.24-36.21-36.21S108.03 41.56 128 41.56M228.43 232.1H27.57c-4.14 0-7.5-3.36-7.5-7.5v-38.02c0-2.52 1.27-4.87 3.37-6.26 2.43-1.6 60.06-39.25 104.55-39.25 48.31 0 102.47 37.78 104.75 39.39a7.51 7.51 0 0 1 3.18 6.13v38.02c0 4.14-3.36 7.5-7.5 7.5Zm-193.36-15h185.85v-26.52c-11.98-7.83-55.6-34.52-92.93-34.52-34.31 0-80.23 26.81-92.93 34.65v26.38Z"
    />
  </svg>
);
export default SvgProfil;
